var _dec, _class, _descriptor, _installGiftCards;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { FirstPartyAddon } from '@square/dashboard-protos/models/squareup/addons/shared/first_party_addons';
import { captureException } from '@sentry/ember';
let GiftCardDefaultsService = (_dec = service('addons/addons'), _class = (_installGiftCards = /*#__PURE__*/new WeakSet(), class GiftCardDefaultsService extends Service {
  constructor(...args) {
    super(...args);
    _classPrivateMethodInitSpec(this, _installGiftCards);
    _initializerDefineProperty(this, "addonsService", _descriptor, this);
    _defineProperty(this, "GiftCardAddonId", FirstPartyAddon.GIFT_CARD);
    _defineProperty(this, "isLoaded", false);
  }
  async setConfigurationDefaults() {
    try {
      if (!this.isLoaded) {
        await _classPrivateMethodGet(this, _installGiftCards, _installGiftCards2).call(this);
      }
    } catch (e) {
      captureException(`Error fetching/setting gift card configuration ${e}`);
    }
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "addonsService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
async function _installGiftCards2() {
  await this.addonsService.installAddon(this.GiftCardAddonId);
  this.isLoaded = true;
}
export { GiftCardDefaultsService as default };